import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  JhaPubSubService,
  JhaPubSubMessage,
} from "@jkhy/responsive-ui-angular/jha-responsive-core";
import { Subscription } from "rxjs";
import { ErrorHandlerService } from "./core/error-handler/error-handler.service";
import { DataService } from "./services/data.service";
import { LoaderService } from "./services/loader.service";
import { Institution } from "./shared/models/institution.model";
import { PFrameRoutes } from "./shared/pframe-routes";
import { PrimeNGConfig } from "primeng/api";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, OnDestroy {
  errorMessageText = "";
  errorMessageTextDisplay = "";
  errorMessage = false;
  loading = false;
  showLogout = false;
  showSwitchInstitution = false;
  switchInstQuestion = "";
  selectedInst: Institution;

  private subscriptions: Subscription[] = [];

  constructor(
    @Inject(JhaPubSubService) private pubSubService: JhaPubSubService,
    private errorSrv: ErrorHandlerService,
    private dataSrv: DataService,
    private loader: LoaderService,
    private router: Router,
    private primengConfig: PrimeNGConfig
  ) {}

  ngOnInit() {
    this.primengConfig.overlayOptions.appendTo = 'body'
    this.subscriptions.push(
      this.errorSrv.getMessage().subscribe((data) => {
        if (
          data !== null &&
          this.errorMessageText &&
          this.errorMessageText.length &&
          this.errorMessageText !== data
        ) {
          this.errorMessage = true;
          this.errorMessageText = data;
          this.errorMessageTextDisplay = data;
        }
      })
    );
    this.subscriptions.push(
      this.pubSubService.Stream.subscribe((pubSubMessage) =>
        this.processAction(pubSubMessage)
      )
    );
    this.loader.loader$.subscribe((loaderStatus) => {
      this.loading = loaderStatus;
    });
  }

  public processAction(pubSubMessage: JhaPubSubMessage): void {
    if (pubSubMessage.message === "ShowLogOutDialog") {
      this.showLogout = true;
    }
    if (pubSubMessage.message === "ShowInstitutionSwitchDialog") {
      this.showSwitchInstitution = true;
      this.selectedInst = pubSubMessage.payload;
      this.switchInstQuestion =
        "Are you sure you want to switch to " +
        this.selectedInst.institutionId +
        "?";
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  public closesSwitchInstitutionPopup(dialogResult: string): void {
    if (dialogResult === "Sure") {
      this.switchInstitution();
      this.dataSrv.switchWKs(this.selectedInst);
      this.pubSubService.Stream.next(new JhaPubSubMessage("InstitutionChanged", null));
    }
  }

  public closesLogoutPopup(dialogResult: string): void {
    if (dialogResult === "Log Out") {
      this.pubSubService.Stream.next(new JhaPubSubMessage("LoggedOut", null));
      this.router.navigate([PFrameRoutes.login]);
    }
  }

  public switchInstitution() {
    this.dataSrv.switchInst(this.selectedInst).subscribe((data) => {
      if (data.status === "S") {
        this.pubSubService.Stream.next(
          new JhaPubSubMessage("UpdatePermissions", null)
        );
      }
    });
  }
}
